export default class Transactions {
  constructor() {
    this.bankAccounts = [];
    this.linkedBankAccounts = [];
    this.brokerageAccounts = [];
    this.linkedBrokerageAccounts = [];
    this.scheduledTransfers = [];
    this.docusignPreviewData = [];
    this.pendingRequests = [];
    this.clientTransactions = [];
    this.eSignatures = [];
    this.clientAcats = [];
    this.resubmitResponse = 0;
    this.holdingsAcats = {};
    this.goalDetail = {};
    this.selectedPendingTransfer = null;
    this.totalTransfersCount = 0;
    this.bankLinksDetails = {};
  }
}
